import airline from './airline/airline'
import configuration from './configuration/configuration'
import creditor from './creditor/creditor'
import debtor from './debtor/debtor'
import debtorTracking from './debtorTracking/debtorTracking'
import expectedInvoices from './invoices/expected'
import incomingInvoices from './invoices/incoming'
import outgoingInvoices from './invoices/outgoing'
import manualInvoices from './invoices/manual'
// import pricelist from './pages/pricelist'

const Menu: any[] = [
  airline,
  configuration,
  creditor,
  debtor,
  expectedInvoices,
  incomingInvoices,
  outgoingInvoices,
  manualInvoices,
  debtorTracking
  // pricelist
]

export default Menu;